import React, { useEffect, useContext, useState, useRef } from 'react';
import config from "config/config";
import { Tab, Box, Tooltip, TextField, Switch, FormControlLabel } from '@mui/material';
import Context from "context/context";
import ReusableTable from "components/table/table";
import Button from '@mui/material/Button';
import "./HRview.css";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Modal from '@mui/material/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { styled } from "@mui/material/styles";
import { tooltipClasses } from "@mui/material/Tooltip";
import { Typography } from "@mui/material";
import { Doughnut } from "react-chartjs-2";

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
    cursor: "pointer",
    backgroundColor: "#002c5d",
    color: "#ffffff",
  },
});

const YearEnd = () => {
    const [ratingData, setRatingData] = useState(null);
  const [yearEndRating, setYearEndRating] = useState('');
  const [year, setYear] = useState('');
  const { state, dispatch } = useContext(Context);
  const [finalReviewList, setFinalReviewList] = useState([]);
  const [count, setCount] = useState(0);
  const [offset, setOffset] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedKpi, setSelectedKpi] = useState(null);
  const [isActive, setIsActive] = useState(false)
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [error, setError] = useState(false);


  const [errors, setErrors] = useState({
    kraCategory: false,
    kpiName: false,
    weightage: false,
    assignedFor: false
  });



  const limit = 10;

  const totalRating = 5; 

  const getColor = (rating) => {
    if (rating >= 4) return "#4CAF50"; // Green
    if (rating >= 3) return "#FF9800"; // Orange
    return "#F44336"; // Red
  };

  useEffect(() => {
  console.log("yearEndRating",yearEndRating)
  }, [yearEndRating]);


  const chartData = {
    labels: ["YearEndRating"],
    datasets: [
      {
        data: [yearEndRating, 5 - yearEndRating],
        backgroundColor: [getColor(yearEndRating), "#ddd"],
        hoverBackgroundColor: ["#388e3c", "#bdbdbd"],
      },
    ],
  };

  const chartOptions = {
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
    },
    plugins: [
      {
        id: "centerText",
        afterDraw: (chart) => {
          const { ctx, chartArea } = chart;
          const centerX =
            chartArea.left + (chartArea.right - chartArea.left) / 2;
          const centerY =
            chartArea.top + (chartArea.bottom - chartArea.top) / 2;

          ctx.save();
          ctx.font = "bold 16px Arial";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillStyle = "#000";
          ctx.fillText(`${yearEndRating.toFixed(1)}/5`, centerX, centerY);
          ctx.restore();
        },
      },
    ],
  };

  const ratingCategories = [
    { label: "Outstanding", range: [4.1, 5] },
    { label: "Exceeds Expectation", range: [3.1, 4] },
    { label: "Met Expectation", range: [2.1, 3] },
    { label: "Met Expectation, but needs improvement", range: [1.1, 2] },
    { label: "Does not meet expectation", range: [0, 1] },
  ];
 

  const getRatingCategory = (rating) => {
    const category = ratingCategories.find(
      (category) => rating >= category.range[0] && rating <= category.range[1]
    );
    return category ? category.label : "Unknown";
  };


  const fetchKpiData = async (search = "") => {
    try {
      const query = encodeURIComponent(
        JSON.stringify({
          offset: (offset - 1) * limit,
          limit: limit,
          searchValue: search,
        })
      );
      dispatch({ type: "SET_LOADING", payload: true });
      const url = `${config.host}/panel/pms/hr/completedReviews?query=${query}`;

      const response = await fetch(url, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response data:", errorData);
        throw new Error(`HTTP error! status: ${response.status}, ${errorData.message || ""}`);
      }

      const data = await response.json();

      if (data.status === "Ok" && Array.isArray(data.data.result)) {
        const formattedData = data.data.result.map((kpi, index) => [
          index + 1 + (offset - 1) * limit,
          kpi.employeeCode,
          kpi.firstName,
          kpi.managerName,
          kpi.role,
          kpi.finalHrRating,
       
          <Tooltip title="Click to view details">
            <span className="jobType">
              <RemoveRedEyeIcon
                style={{ color: '#E97000', cursor: 'pointer' }}
                onClick={() => handleViewClick(kpi.employeeAssessmentsId)}
              />
            </span>
          </Tooltip>,
        ]);
        setFinalReviewList(formattedData);
        setCount(data.data.count);
        dispatch({ type: "SET_LOADING", payload: false });
      }else if (data.data.error) {
        // If there's an error in the data, display it via toast
        console.error("Error from API:", data.data.error);
        toast.error(data.data.error, { toastId: "error-message" });
        setFinalReviewList([]); // Optionally clear the finalReviewList
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        console.error("Unexpected data format:", data);
        setFinalReviewList([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    }
  };

  const handleSaveyearrating = async (yearEndRatingsId) => {

    try {
      const url = `${config.host}/panel/pms/hr/saveRating`;
  
      const body = {
        yearEndRatingsId: yearEndRatingsId,
        yearEndRating: parseFloat(yearEndRating), 
      };
  
      dispatch({ type: "SET_LOADING", payload: true });
  
      const response = await fetch(url, {
        method: "POST",
        credentials: "include", 
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response data:", errorData);
        throw new Error(`HTTP error! status: ${response.status}, ${errorData.message || ""}`);
      }
  
      const data = await response.json();
  
      if (data.status === "Ok" && data.data.updated === 1) {
        toast.success("Year-end rating saved successfully!");
        setOpenModal(false)
        fetchKpiData()
       
      } else {
        console.error("Error saving rating:", data);
      }
  
      dispatch({ type: "SET_LOADING", payload: false });
  
    } catch (error) {
      console.error("Error saving Year End Rating:", error);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  useEffect(() => {
    fetchKpiData(searchValue);
  }, [offset, searchValue]);



  const handleViewClick = async (employeeAssessmentsId) => {
    try {
      const url = `${config.host}/panel/pms/hr/yearEndRatings?employeeAssessmentsId=${employeeAssessmentsId}`;
      dispatch({ type: "SET_LOADING", payload: true });
  
      const response = await fetch(url, {
        method: "GET",
        credentials: "include", 
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response data:", errorData);
        throw new Error(`HTTP error! status: ${response.status}, ${errorData.message || ""}`);
      }
  
      const data = await response.json();
  
      if (data.status === "Ok" && Array.isArray(data.data.result)) {
        const result = data.data.result[0];
        
        setRatingData(result);
        setYearEndRating(result.finalHrRating); 
        setYear(result.year)
        setOpenModal(true);
        dispatch({ type: "SET_LOADING", payload: false });
      } else {
        console.error("Unexpected data format:", data);
        setRatingData(null);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (error) {
      console.error("Error fetching Year End Ratings data:", error);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };


  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedKpi(null);
    setErrors({});
    setIsActive(false);
  };


 
  const handlePublish = () => {
    setOpenPublishModal(true);
  };

  // Close the modal
  const handleClosepublishModal = () => {
    setOpenPublishModal(false);
  };

  const handleConfirmPublish = async () => {
    dispatch({ type: "SET_LOADING", payload: true });

    try {
      const response = await fetch(`${config.host}/panel/pms/hr/publishRatings`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error publishing ratings:", errorData);
        toast.error("Failed to publish ratings");
        dispatch({ type: "SET_LOADING", payload: false });

        return;
      }

      const result = await response.json();
      if (result.status === "Ok" && result.data.updated > 0) {
        toast.success("Ratings published successfully");
        dispatch({ type: "SET_LOADING", payload: false });

      } else {
        toast.error("No ratings were updated");
        dispatch({ type: "SET_LOADING", payload: false });

      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("An error occurred while publishing ratings");
      dispatch({ type: "SET_LOADING", payload: false });

    } finally {
      setOpenPublishModal(false); // Close modal after API call
      dispatch({ type: "SET_LOADING", payload: false });

    }
  };

  const handleYearEndRatingChange = (e) => {
    const value = e.target.value;

    // Validate that the value is a number between 0 and 5
    if (value === "" || (Number(value) >= 0 && Number(value) <= 5)) {
      setError(false); // Reset error if valid
      setYearEndRating(value); // Update the yearEndRating state
    } else {
      setError(true); // Set error if invalid input
    }
  };



  return (
    <div style={{ backgroundColor: "white", borderRadius: "10px" }}>
      <Box sx={{ width: '100%', typography: 'body1' }}>
         
         

            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: '100%', overflowX: 'auto' }}>

                <ReusableTable
                  title={<div className="leavemanageHeading">Year End Rating</div>
                  }
                  create={<Button className="AddKrabutton" onClick={handlePublish}>
                    Publish
                  </Button>}
                  searchBar
                  data={Array.isArray(finalReviewList) ? finalReviewList : []}
                  count={count}
                  offset={offset}
                  setOffset={setOffset}
                  limit={limit}
                  setSearchValue={setSearchValue}
                  heading={["S.No", "Employee ID", "Employee Name", "Reporting", "Role","Final Rating", "Action"]}
                  placeholder="Search Employee..."
                />
              </div>
            </div>
          
         
      </Box>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <div className="yearend-modal-content">
          <h2>Year End Ratings</h2>
          <div className="yearend-modal-body">
            {/* Doughnut chart on the left */}
            <div className="yearend-chart-container"  style={{
        position: "relative",
        width: "300px",
        height: "400px", // Increased height for category display
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
              <Doughnut data={chartData} />
             
              <div
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontSize: "20px",
      fontWeight: "bold",
    }}
  >
    {yearEndRating}/5
  </div>
  <div
        style={{
          marginTop: "20px",
          fontSize: "16px",
          fontWeight: "bold",
          color: "#333",
          textAlign: "center",
        }}
      >
        {getRatingCategory(yearEndRating)}
      </div>
            </div>

            {/* Text fields for ratings and Year End Rating on the right */}
            <div className="yearend-textfields">
              {ratingData && (
                <>
                  <TextField
                    className="yearend-textfield"
                    label="Q1 Rating"
                    value={ratingData.Q1Rating}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                  <TextField
                    className="yearend-textfield"
                    label="Q2 Rating"
                    value={ratingData.Q2Rating}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                  <TextField
                    className="yearend-textfield"
                    label="Q3 Rating"
                    value={ratingData.Q3Rating}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                  <TextField
                    className="yearend-textfield"
                    label="Q4 Rating"
                    value={ratingData.Q4Rating}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                   <TextField
                    className="yearend-textfield"
                    label="Overall Rating"
                    value={ratingData.YearEndRating}
                    InputProps={{ readOnly: true }}
                    variant="outlined"
                  />
                 <TextField
        className="yearend-textfield"
        label="Year End Rating"
        value={yearEndRating}
        onChange={handleYearEndRatingChange}
        variant="outlined"
        helperText={error ? "Enter a rating between 0 and 5." : " "}
        error={error} // Set error state to highlight invalid input
        inputProps={{
          inputMode: "numeric", // Allow only numeric input
          pattern: "[0-5]*", // Regex pattern to restrict numbers between 0 and 5
        }}
      />
                </>
              )}
            </div>
          </div>

          <div className="yearend-modal-buttons">
            <Button onClick={() =>handleSaveyearrating(ratingData.yearEndRatingsId)} className="self-saveButton">
              Save
            </Button>
            <Button onClick={() => setOpenModal(false)} className="self-cancelButton">
              Close
            </Button>
          </div>
        </div>

      </Modal>


      <Modal
        open={openPublishModal}
        onClose={handleCloseModal}
        aria-labelledby="publish-confirmation-title"
        aria-describedby="publish-confirmation-description"
      >
        <div
          style={{
            width: "400px",
            margin: "auto",
            marginTop: "15%",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
            textAlign: "center",
          }}
        >
          <Typography id="publish-confirmation-title" variant="h6">
            Confirm Publish
          </Typography>
          <Typography
            id="publish-confirmation-description"
            style={{ marginTop: "10px", color: "#666" }}
          >
            Once published, ratings cannot be changed. Are you sure you want to
            proceed?
          </Typography>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button variant="outlined" onClick={handleClosepublishModal}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirmPublish}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Modal>
      {/* Add Kra/Kpi modal */}
      


    </div>
  );
};

export default YearEnd;